import { render, staticRenderFns } from "./center_3.vue?vue&type=template&id=1c30a2c7&scoped=true&"
import script from "./center_3.vue?vue&type=script&lang=js&"
export * from "./center_3.vue?vue&type=script&lang=js&"
import style0 from "./center_3.vue?vue&type=style&index=0&id=1c30a2c7&lang=scss&scoped=true&"
import style1 from "./center_3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c30a2c7",
  null
  
)

export default component.exports